import React, { useState } from 'react';

// gallery-bookmark-shared: keep someone else's shared card in your Gallery, as a link to the
// original. `bookmarked` comes from the embed response; null means the viewer can't bookmark
// (signed out, or it's their own card), so nothing renders.
export default function GalleryBookmarkButton({ embedId, bookmarked, onChange }) {
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  if (bookmarked == null || !embedId) return null;

  const toggle = async () => {
    setBusy(true);
    setFailed(false);
    try {
      const res = bookmarked
        ? await fetch(`/api/gallery/bookmarks/${encodeURIComponent(embedId)}`, {
          method: 'DELETE', credentials: 'same-origin' })
        : await fetch('/api/gallery/bookmarks', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: embedId }),
        });
      if (res.ok) onChange(!bookmarked);
      else setFailed(true);
    } catch (e) {
      setFailed(true);
    } finally {
      setBusy(false);
    }
  };

  const label = failed ? 'Couldn’t save — retry'
    : bookmarked ? 'In your gallery' : 'Add to gallery';
  return (
    <button
      type="button" onClick={toggle} disabled={busy}
      title={bookmarked ? 'Remove from your gallery' : 'Keep a link to this shared card in your gallery'}
      style={{
        background: bookmarked ? '#f1f5f9' : 'none',
        border: '1px solid #cbd5e1', borderRadius: 6, padding: '4px 10px',
        fontSize: '0.8rem', color: failed ? '#b91c1c' : '#334155',
        cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.6 : 1,
      }}>
      {label}{bookmarked ? ' ★' : ' ☆'}
    </button>
  );
}
